// ============================================================================
// CHANGO V5.0 — D6.6 Mail-inbound ops — pure helpers
// ============================================================================
// Pure client-side filter helpers for the email_replies admin list. The
// list endpoint already supports ?status=, but sender-domain filtering is
// applied client-side against the returned (redacted) from_email.
// ============================================================================

// Redacted form from the backend is like "a***@example.com".
// Extract the domain suffix (after the last '@'). Returns null on malformed.
export function extractDomain(redactedEmail) {
  if (typeof redactedEmail !== 'string') return null;
  const at = redactedEmail.lastIndexOf('@');
  if (at < 0 || at === redactedEmail.length - 1) return null;
  const host = redactedEmail.slice(at + 1).trim().toLowerCase();
  if (!host.includes('.')) return null;
  return host;
}

// True if the row's redacted from_email matches the sender-domain filter.
// Empty filter matches everything. The comparison is exact-suffix, so
// typing "example.com" matches "a***@example.com" but not
// "a***@foo.example.com.evil.tld". We support the leading "@" as a
// convenience (users naturally type "@example.com").
export function matchesDomainFilter(row, filter) {
  if (!filter) return true;
  const needle = String(filter).trim().toLowerCase().replace(/^@/, '');
  if (!needle) return true;
  const host = extractDomain(row?.from_email);
  if (!host) return false;
  return host === needle;
}

// Status display metadata mirrors the Chinese ops vocabulary used in
// OpsReviewInbox for visual consistency.
export const STATUS_META = Object.freeze({
  received: { label: '待处理', tone: 'bg-amber-200 text-amber-900' },
  posted:   { label: '已发布', tone: 'bg-emerald-200 text-emerald-900' },
  ignored:  { label: '已忽略', tone: 'bg-slate-300 text-slate-700' },
});
